/* eslint-disable camelcase */
import { Spinner, Stack } from 'component-library';
import { Trans } from 'react-i18next';

import { IndicatorProduct } from '@/api/rest/resources/types/IndicatorProduct';
import { withSuspenseBoundary } from '@/components/SuspenseBoundary';
import { SpinnerWidget } from '@/components/widgets/a/Spinner/Spinner';
import { useIndicatorProductCalcualtionProgress } from '@/hooks/useIndicatorProductCalculationProgress';
import { isNullish } from '@/utils/booleans';

export const CalculationProgress = withSuspenseBoundary(
  ({ id, show_calculation_progress = false }: Pick<IndicatorProduct, 'id' | 'show_calculation_progress'>) => {
    const indicatorProductsCalcualtionProgress = useIndicatorProductCalcualtionProgress(id).data;

    if (!show_calculation_progress) {
      return null;
    }

    const { completed_fact_count, expected_fact_count } = indicatorProductsCalcualtionProgress ?? {};

    const isCalculationInProgress =
      !isNullish(completed_fact_count) &&
      !isNullish(expected_fact_count) &&
      completed_fact_count !== expected_fact_count;

    return (
      <>
        {isCalculationInProgress && (
          <Stack
            className='typography-body2'
            direction='row'
            centerMain
            spacing={1}
            data-testid='indicator-library-card-calculation-progress'
          >
            <SpinnerWidget
              direction='row'
              spacing={2}
              centerMain
              size={3}
              label={{
                children: (
                  <Trans
                    i18nKey='global.widget.indicatorLibraryCard.calculationProgress'
                    values={{ completedAssets: completed_fact_count, expectedAssets: expected_fact_count }}
                    components={{
                      strong: <span className='typography-body1Semibold' />,
                    }}
                  />
                ),
              }}
            />
          </Stack>
        )}
      </>
    );
  },
  <Stack centerMain>
    <Spinner size={4} />
  </Stack>,
);
